export const informCustomEvent = (eventName, data = {}) => {
    if(window.gtag){
        typeof window !== "undefined" && (window.gtag ? window.gtag("event", eventName):'')
    }
}